import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridRows = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9998 3C20.7219 3 21.5 3.77778 21.5 6.5C21.5 9.22222 20.6919 10 17.9998 10L6.99982 10C4.30769 10 3.5 9.22222 3.5 6.5C3.5 3.77778 4.27778 3 6.99982 3L17.9998 3Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9998 14C20.7219 14 21.5 14.7778 21.5 17.5C21.5 20.2222 20.6919 21 17.9998 21L6.99982 21C4.30769 21 3.5 20.2222 3.5 17.5C3.5 14.7778 4.27778 14 6.99982 14L17.9998 14Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgGridRows);
export { ForwardRef as ReactComponent };
